export default __webpack_public_path__ + "static/unimpressed-blurry-f41c61b974815ec9a8bcb9102398d513.png";